import axios, { AxiosResponse } from 'axios';
import { Feature, ZoomAppUser } from './models';

const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
const modelsResultsAxios = axios.create({
  baseURL: 'https://dev-models-results.talka.ai',
  headers,
});

export const getZoomAppUser = async (
  deviceAuthToken: string
): Promise<AxiosResponse<ZoomAppUser>> => {
  return modelsResultsAxios({
    method: 'get',
    url: '/zoom_app_user',
    headers: {
      'zoom-app-auth-token': deviceAuthToken,
    },
  });
};

export const getZoomAppLiveMeetings = async (
  deviceAuthToken: string
): Promise<AxiosResponse<string[]>> => {
  return modelsResultsAxios({
    method: 'get',
    url: '/zoom_app_live_meetings',
    headers: {
      'zoom-app-auth-token': deviceAuthToken,
    },
  });
};

export const getZoomAppInsights = async (
  deviceAuthToken: string,
  liveMeetingIds: string[],
  speakerName: string
): Promise<AxiosResponse<Feature[]>> => {
  return modelsResultsAxios({
    method: 'get',
    url: '/zoom_app_insights',
    headers: {
      'zoom-app-auth-token': deviceAuthToken,
    },
    params: {
      'live-meeting-ids': liveMeetingIds.join(','),
      'speaker-name': speakerName,
    },
  });
};
